export default "/images/sddb-app.png";